import { useEffect, useState } from "react";
import { answerMatches } from "@/lib/speech";
import { SpeakButton } from "@/components/SpeakButton";

export const TextExercise = ({ ex, lang, locked, onSubmit, onChange }) => {
  const [value, setValue] = useState("");
  useEffect(() => setValue(""), [ex]);
  const isFill = ex.type === "fill_blank";

  const update = (v) => {
    setValue(v);
    onChange?.(v);
  };
  const isJa = lang === "ja";
  const shown = ex.answer_romaji ? `${ex.answer} (${ex.answer_romaji})` : ex.answer;
  const check = () => onSubmit(answerMatches(value, [ex.answer, ex.answer_romaji, ex.romaji, ...(ex.accepted || [])]), shown);

  return (
    <div>
      {isFill ? (
        <div className="rounded-2xl bg-slate-50 border border-slate-200 p-5 mb-4">
          <div className="flex items-start gap-3">
            <p className="text-xl font-semibold text-slate-900 flex-1 leading-relaxed">{ex.prompt}</p>
            <SpeakButton text={ex.prompt.replace(/_+/g, "...")} lang={lang} testId="fill-prompt-speak" showSlow={false} />
          </div>
          {ex.prompt_romaji && <p data-testid="fill-prompt-romaji" className="text-sm text-[hsl(var(--accent-blue))] font-semibold mt-1">{ex.prompt_romaji}</p>}
          {ex.hint && <p className="text-sm text-slate-500 mt-2">{ex.hint}</p>}
        </div>
      ) : (
        <div className="rounded-2xl bg-slate-50 border border-slate-200 p-5 mb-4">
          <p className="caption mb-1">Translate into the target language</p>
          <p className="text-xl font-semibold text-slate-900">{ex.prompt}</p>
        </div>
      )}
      <textarea
        data-testid="exercise-text-input"
        value={value}
        disabled={locked}
        rows={isFill ? 1 : 2}
        onChange={(e) => update(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey && onSubmit && value.trim() && !locked) { e.preventDefault(); check(); }
        }}
        placeholder={isJa ? (isFill ? "Type the missing word in romaji or Japanese" : "Type in romaji (e.g. konnichiwa) or Japanese") : isFill ? "Type the missing word" : "Type your translation"}
        className="w-full rounded-2xl border-2 border-slate-200 focus:border-[hsl(var(--primary))] focus:outline-none px-4 py-3 text-lg resize-none bg-white"
      />
      {isJa && <p data-testid="romaji-ok-note" className="text-xs text-slate-500 mt-2">Romaji is totally fine, no Japanese keyboard needed. Long vowels like "ou" or "o" both count.</p>}
      {onSubmit && !locked && (
        <button data-testid="exercise-check-button" disabled={!value.trim()} onClick={check} className="btn-primary w-full mt-4">
          Check
        </button>
      )}
    </div>
  );
};
